import { render, staticRenderFns } from "./AmortisationSchedule.vue?vue&type=template&id=2a0bbb4a"
import script from "./AmortisationSchedule.vue?vue&type=script&lang=js"
export * from "./AmortisationSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports